var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.98535 0.645996C2.3285 0.645996 0.985352 1.98914 0.985352 3.646V26.646C0.985352 28.3029 2.3285 29.646 3.98535 29.646H26.9854C28.6422 29.646 29.9854 28.3029 29.9854 26.646V3.646C29.9854 1.98914 28.6422 0.645996 26.9854 0.645996H3.98535ZM22.7511 10.0195C23.5322 9.92247 24.286 9.71953 24.9854 9.4107C24.4586 10.1783 23.8047 10.8489 23.0418 11.3783C23.0508 11.546 23.0508 11.7048 23.0508 11.8725C23.0508 16.8754 19.1182 22.646 11.9615 22.646C9.76355 22.646 7.71097 22.0195 5.98535 20.9431C6.29415 20.9783 6.60294 20.996 6.91174 20.996C8.74635 20.996 10.4266 20.396 11.7526 19.3725C10.036 19.346 8.61011 18.2342 8.11967 16.7431C8.35581 16.7872 8.60103 16.8136 8.84625 16.8136C9.20046 16.8136 9.54558 16.7695 9.87254 16.6813C8.09243 16.3372 6.74826 14.8019 6.74826 12.9666V12.9401C7.27503 13.2048 7.87445 13.3813 8.51929 13.3813C7.46575 12.7195 6.78459 11.5548 6.78459 10.2401C6.78459 9.55188 6.97531 8.89894 7.31136 8.34305C9.2277 10.6283 12.1068 12.1372 15.34 12.296C15.2765 12.0225 15.2401 11.7313 15.2401 11.4313C15.2401 9.34011 16.9839 7.646 19.1182 7.646C20.2626 7.646 21.2707 8.08717 21.9882 8.846C22.8692 8.66953 23.7048 8.3607 24.4586 7.91953C24.168 8.8107 23.5504 9.55188 22.7511 10.0195Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/Twitter.0750f77c5266b24cb57d944f370aa428.svg";
export { ForwardRef as ReactComponent };